<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="193" height="194" viewBox="0 0 193 194">
        <defs>
            <filter id="Ellipse_48" x="0" y="0" width="193" height="194" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="7.5" result="blur"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="blur"/>
                <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g id="Group_2039" data-name="Group 2039" transform="translate(22.052 22.5)">
            <g transform="matrix(1, 0, 0, 1, -22.05, -22.5)" filter="url(#Ellipse_48)">
                <ellipse id="Ellipse_48-2" data-name="Ellipse 48" cx="74" cy="74.5" rx="74" ry="74.5" transform="translate(22.5 22.5)" fill="#a6ce38"/>
            </g>
            <g id="Group_2034" data-name="Group 2034" transform="translate(35.089 33.837)">
                <path id="Path_615" data-name="Path 615" d="M739.778,222.523h78.353V174.655l-39.177-28.709-39.177,28.709v47.867Z" transform="translate(-739.778 -145.947)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <path id="Path_616" data-name="Path 616" d="M818.132,196.7l-39.177-32.08L739.778,196.7" transform="translate(-739.778 -120.124)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <line id="Line_12" data-name="Line 12" x2="28.504" y2="21.598" transform="translate(0.823 29.868)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <line id="Line_13" data-name="Line 13" x1="28.504" y2="21.598" transform="translate(49.025 29.868)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            </g>
        </g>
    </svg>




</template>

<script>
export default {
    name: "svg-location"
}
</script>

<style scoped lang="scss">
svg {
    transition: 200ms all ease-in-out;
    &:hover {
        transform: scale(1.1);
    }
}
</style>
